exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container.expand[data-v-671c4558]{height:auto}.info-leave-active[data-v-671c4558],.info-leave[data-v-671c4558]{animation-name:disappearContent;animation-duration:.5s;animation-timing-function:cubic-bezier(.4,0,.2,1);animation-fill-mode:forwards}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-671c4558&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 60
// module chunks = 0